import enMessage from './en.json'
import viMessage from './vi.json'

const _flattenMessages = (nestedMessages, prefix = '') => {
    const parsed = Object.assign({}, nestedMessages)

    return Object.keys(parsed).reduce((messages, key) => {
        let value = parsed[key]
        let prefixedKey = prefix ? `${prefix}.${key}` : key

        if (typeof value === 'string') {
            messages[prefixedKey] = value
        } else {
            Object.assign(messages, _flattenMessages(value, prefixedKey))
        }

        return messages
    }, {})
}

const messages = {
    en: _flattenMessages(enMessage),
    vi: _flattenMessages(viMessage),
}

export default messages
